import './css/divider.css';

export default function Divider() {
  return (
    <div className="divider">
      <div className="border"></div>
      <span>OR</span>
      <div className="border"></div>
    </div>
  );
}
